import { css } from "@emotion/react";
import { memo } from "react";
import { yokaiZukan } from "../../../consts";
import YokaiCard from "../YokaiCard";

const Yokai = () => {
  return (
    <div
      id="yokai"
      css={css`
        background-image: url(/img/bg.jpg);
        background-color: #fff;
      `}
    >
      <div
        css={css`
          padding: 100px;
          max-width: 860px;
          margin: 0 auto;
          padding: 120px 10px 180px;
        `}
      >
        <div
          css={css`
            display: flex;
            justify-content: space-between;
            margin-bottom: 80px;
            @media screen and (max-width: 1024px) {
              flex-direction: column;
            }
          `}
        >
          <div>
            <h2
              css={css`
                font-family: "Bebas Neue", cursive;
                font-size: 78px;
                font-weight: 300;
              `}
            >
              “Yokai”
            </h2>
            <span
              css={css`
                font-size: 26px;
                font-weight: 600;
                display: inline-block;
                transform: translateY(-30px);
              `}
            >
              -{" "}
              <span
                css={css`
                  color: #e63c3c;
                `}
              >
                Who
              </span>{" "}
              are they?
            </span>
          </div>
          <p
            css={css`
              max-width: 580px;
            `}
          >
            Japanese folklore is really filled with mythical creatures. We call
            it “Yokai”. They look scary. but are really big parts of the
            culture. “Yokai” is sometimes called “demon” in other countries, but
            if you see the pictures posted below, you can feel the slight
            differences between them in terms of their visuals and the
            atmospheres. Very unique right?
            <br />
            <br />
            Of course, there are actually many kinds of Yokai in Japanese Emaki
            history, and we have a total of{" "}
            <span
              css={css`
                font-weight: 600;
              `}
            >
              12 Japanese Yokai
            </span>{" "}
            appearing in our NFT. So let me just introduce them.
          </p>
        </div>
        <div
          css={css`
            display: flex;
            flex-direction: column;
            gap: 42px;
            @media screen and (max-width: 1024px) {
              gap: 86px;
            }
          `}
        >
          {yokaiZukan.map((yokai, i) => (
            <YokaiCard key={i} yokai={yokai} isLeft={i % 2 !== 0} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default memo(Yokai);
